import jwtDecode from "jwt-decode";
import { UserType } from "../models/ModelTypes";

const getUserInfo = (token: string): UserType => {
  return jwtDecode(token);
};

export default getUserInfo;
